import dayjs from 'dayjs';

import { ValueStub } from 'constants/data';
import { COMMON_DATE_FORMAT } from 'constants/date';

export const getSignedOffMetaLabel = ({ signedOffBy, signedOffDate }) => {
  const author = signedOffBy && signedOffBy !== ValueStub.ALTERNATE ? signedOffBy : null;
  const date = signedOffDate ? dayjs(signedOffDate).format(COMMON_DATE_FORMAT) : null;

  if (author && date) {
    return `by ${author} · ${date}`;
  }

  if (author) {
    return `by ${author}`;
  }

  if (date) {
    return date;
  }

  return null;
};
